import { IDeleteItemFolhaPagamentoVerbaUseCase } from "../../../presentation/useCases/delete/delete_item_folha_pagamento_verba_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteItemFolhaPagamentoVerbaUseCase
 */

export class DeleteItemFolhaPagamentoVerbaUseCase implements IDeleteItemFolhaPagamentoVerbaUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteItemFolhaPagamentoVerba(
    idItemFolhaPagamentoVerba: number,
  ): Promise<void> {
    await this.repository.deleteItemFolhaPagamentoVerba(
      idItemFolhaPagamentoVerba,
    );
  }
}
